if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector("button");
            if (button)
              button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute("available");
        }
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);

        this.querySelector("button").addEventListener(
          "click",
          this.onClickRefreshList
        );
      }

      renderPreview(sectionInnerHTML) {
        // Remove any existing drawer
        const drawer = document.querySelector("pickup-availability-drawer");
        if (drawer) drawer.remove();

        // If there's no pickup-availability-preview in the snippet, remove ourselves
        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        // Inject the preview HTML
        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview"
        ).outerHTML;
        this.setAttribute("available", "");

        // Append the drawer
        document.body.appendChild(
          sectionInnerHTML.querySelector("pickup-availability-drawer")
        );

        // *** NEW: run our "Collect from X date" logic now that snippet is appended
        this.runCollectDateLogic();
      }

      // *** NEW FUNCTION: This will find data-physically-in-stock and #collectDate, then set the text
      runCollectDateLogic() {
        // 1) Check if we have the .pickup-availability-details element
        const detailsEl = document.querySelector(".pickup-availability-details");
        if (!detailsEl) return; // no element found

        // 2) Read the data attribute
        const physicallyInStock = detailsEl.dataset.physicallyInStock === "true";

        // 3) We'll compute the earliest pickup date
        const pickupText = computeCollectDate(physicallyInStock);

        // 4) Insert into #collectDate
        const collectSpan = detailsEl.querySelector("#collectDate");
        if (collectSpan) {
          collectSpan.textContent = pickupText;
        }
      }
    }
  );
}

// *** HELPER: We'll define the function to compute "Collect from X date" outside the class
function computeCollectDate(physicallyInStock) {
  // Here is your store schedule logic

  // 1) Define store schedule (Mon/Fri/Sat/Sun open 10-16, closed Tue/Wed/Thu)
  function getStoreStatus(date) {
    const dayIndex = date.getDay(); // 0=Sun, 1=Mon, etc.
    const hour = date.getHours();
    const schedule = {
      0: { open: true, openTime: 10, closeTime: 16 },
      1: { open: true, openTime: 10, closeTime: 16 },
      2: { open: false },
      3: { open: false },
      4: { open: false },
      5: { open: true, openTime: 10, closeTime: 16 },
      6: { open: true, openTime: 10, closeTime: 16 },
    };
    const info = schedule[dayIndex];
    if (!info.open) return { open: false };
    const isOpenNow = hour >= info.openTime && hour < info.closeTime;
    return { open: true, isOpenNow, openTime: info.openTime, closeTime: info.closeTime };
  }

  // 2) Find next open day if needed
  function findNextOpenDay(date) {
    let temp = new Date(date.getTime());
    for (let i = 0; i < 7; i++) {
      temp.setDate(temp.getDate() + 1);
      const st = getStoreStatus(temp);
      if (st.open) return temp;
    }
    return null;
  }

  // 3) Format date like "Mon 20 Feb"
  function formatDate(date) {
    return date.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  }

  const now = new Date();
  let pickupText = "...";
  const statusToday = getStoreStatus(now);

  if (physicallyInStock) {
    // "Usually ready in 2 hours" logic
    if (statusToday.open) {
      if (now.getHours() < 15) {
        pickupText = "Today";
      } else {
        const nextOpen = findNextOpenDay(now);
        pickupText = nextOpen ? formatDate(nextOpen) : "No open day found";
      }
    } else {
      const nextOpen = findNextOpenDay(now);
      pickupText = nextOpen ? formatDate(nextOpen) : "No open day found";
    }
  } else {
    // "Usually ready in 24 hours" logic
    let temp = new Date(now.getTime());
    temp.setDate(temp.getDate() + 1);
    for (let i = 0; i < 7; i++) {
      const st = getStoreStatus(temp);
      if (st.open) {
        pickupText = formatDate(temp) + " after 1pm";
        break;
      }
      temp.setDate(temp.getDate() + 1);
    }
    if (pickupText === "...") {
      pickupText = "No open day found in the next week";
    }
  }

  return pickupText;
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends BasicModal {
      constructor() {
        super();
      }
    }
  );
}